import {Pipe, PipeTransform} from "@angular/core";
import {UtilitiesService} from "../../core/_services/utilities.service";
import {Job} from "../_models/job";
import {JobRequest} from "../_models/jobRequest";

@Pipe({
    name: 'filterByContact'
})
export class FilterByContactPipe implements PipeTransform {

    transform(jobs: (Job | JobRequest)[], args: string | number): any {
        if (UtilitiesService.isEmpty(jobs)) {
            return [];
        }

        const contactId = Number(args);
        if (UtilitiesService.isEmpty(args) || contactId === 0) {
            return jobs;
        }

        return jobs.filter(j => j.contactId === contactId);
    } // transform()

} // FilterByContactPipe
